export default __webpack_public_path__ + "static/media/logo.4456e26a.png";